// removed by extract-text-webpack-plugin
module.exports = {"login-to-see-price":"login-to-see-price___TWjeS","icon-link":"icon-link___3edRS","oval":"oval___3EyMg","icon":"icon___9mquq","link":"link___osGH7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemPriceGateway/ItemPriceGatewayContainer.scss
// module id = KlEt
// module chunks = 46